import { useMutation, useQueryClient } from '@tanstack/react-query';
import DropshipmentService from '@/services/DropshipmentService';
import type { OrderAddress } from '@/services/DropshipmentService';
import { DROPSHIPMENT_KEYS } from './keys';

// Validate a shipping address before placing the order (resolves {valid, errors};
// status is 0 even for an invalid address, so this rejects only on a transport error).
export function useVerifyAddress() {
  return useMutation({
    mutationFn: (orderAddress: OrderAddress) => DropshipmentService.verifyAddress(orderAddress),
  });
}

// Create a device dropshipment order. On success, invalidate the patient's order
// list so the "Recent orders" section refetches (ws() rejects on any non-zero status).
export function useCreateDeviceOrder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      userid: string | number;
      products?: string[];
      partnerRefs?: string[];
      orderAddress: OrderAddress;
    }) => (
      DropshipmentService.createOrderForPatient(vars)
    ),
    onSuccess: (_data, vars) => qc.invalidateQueries({ queryKey: DROPSHIPMENT_KEYS.orders(vars.userid) }),
  });
}
